<!-- @format -->

<ng-container *ngIf="latestReview$ | async as reviews">
	<ng-container *ngIf="productInformation$ | async as productInformation">
		<ng-container *ngIf="reviews.length > 0">
			<div class="hmf-display-flex hmf-flex-column hmf-mx-0 hmf-mt-m hmf-pl-s">
				<product-reviews-review-slider
					class="latest-slider-content"
					[selector]="'latest'">
					<ng-container
						*ngFor="let review of reviews; trackBy: trackByReview"
						carouselContent>
						<product-reviews-review-card
							[review]="review"
							[product]="productInformation"></product-reviews-review-card>
					</ng-container>
				</product-reviews-review-slider>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
